import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { SlackIcon } from './SlackIcon';

export default createWebRegistration({
  authProviders: {
    slack: {
      icon: SlackIcon,
      benefit: 'Enables conversational control and real-time notifications',
    },
  },
});
